<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";
import { isActionVisible } from "@/components/utils/actions";
import { injectStrict } from "@/utils/vue";

import ChangeArt from "./ChangeArt.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);
</script>

<template>
  <ActionMenuDropdown v-if="isActionVisible('art', card, board)" :action="cardActions.setArt">
    <ChangeArt />
  </ActionMenuDropdown>
</template>
